 import link from "@/scripts/host.js";
 import loggedIn from '@/scripts/logged.js';


export default {
  name: "yourNotes",
  props: ["username", "email", "refreshNotes"],
  data() {
    return {
      listType: 1,
      lists: [],
      pagesNr: 1,
      currentPage: 1,
      singleNoteCurrentPage: 1,
      singleNotePagesNr: 1,
      singleNote: false,
      singleNoteList: [],
      playingNow: 99999999,
    };
  },
  computed: {
    paramethers() {
      return this.$route.path;
    },
  },
  methods: {
    async getInfo(type, page) {
      let token = await loggedIn();

        this.axios({
            method: "get",
            url:`${link.hostLink}User/GetUserVotesChartsList?ListTypeId=${type}&PageSize=10&Skip=${(page-1)*10}`,

            headers: {authorization: `bearer ${token}`}
          })
            .then((res)=>{
             this.lists = res.data.data;
             this.pagesNr = Math.ceil(res.data.total/10)
             
            })
            
    },
    async loadSingleNote(id, index, page = 1) {
      let token = await loggedIn();

        this.axios({
            method: "get",
            url:`${link.hostLink}User/GetUserSongsByList?ListId=${id}&PageSize=10&Skip=${(page-1)*10}`,
            headers: {authorization: `bearer ${token}`}
          })
            .then((res)=>{
             this.singleNoteList = res.data.data;
             this.singleNote = [this.lists[index], index];
             this.singleNotePagesNr = Math.ceil(res.data.total/10);
             
            })
           
           

    },
    goToArtistSite(id) {
        if (!this.$route.path.includes("artysta")) {
            this.$store.dispatch("toggleLoginModal");

          this.$router.push(`/artysta/${id}`);
        }
      },
      goToSong(id) {
        if (!this.$route.path.includes(`/utwór/${id}`)) {
            this.$store.dispatch("toggleLoginModal");

          this.$router.push(`/utwór/${id}`);
        }
      },
      goToNote(id) {
       
            this.$store.dispatch("toggleLoginModal");

            if (this.listType == 1) {
        this.$router.push(`/lp3/${id}`);
      } else if (this.listType == 3) {
        this.$router.push(`/polskitopwszechczasow/${id}`);
      } else if (this.listType == 2) {
        this.$router.push(`/topwszechczasow/${id}`);
      } 
      },
      playMP3(mp3) {
        if (this.$refs.audio.src == mp3) {
            
            this.$refs.audio.pause();
            this.$refs.audio.src = "";
       
        } else {
            this.$refs.audio.src = mp3;
            this.$refs.audio.play();
        }
      },
  },
  mounted() {
    this.getInfo(this.listType, this.currentPage);
  },
  watch: {
    listType() {
        this.currentPage = 1;
        this.getInfo(this.listType, this.currentPage);
    },
    currentPage() {
        this.getInfo(this.listType, this.currentPage);


    },
    singleNoteCurrentPage() {
        this.loadSingleNote(this.lists[this.singleNote[1]].listId, this.singleNote[1], this.singleNoteCurrentPage);


    },
    refreshNotes() {
        this.singleNote = false;
        this.currentPage = 1;
        this.listType = 1;

    }
    
  },
};
